import React from 'react';

import './index.scss';

// eslint-disable-next-line react/prop-types
export default function TitleBold({ children }) {
  return (
    <div className="title-bold">{ children }</div>
  );
}
